<template>
    <div class="loading-box" v-show="loadingV.show">
        <div class="loading-icon" style="" data-loader="circle-side"></div>
        <p class="loading-text">{{ loadingV.tip }}</p>
        <div class="loading-mask"></div>
    </div>
</template>
<script>

    import 'css-loading'
    import {mapGetters} from 'vuex'

    export default {
        name: 'loadingV',
        computed: {
            ...mapGetters("modal", {
                loadingV: "getMLoadingV",
            })
        },

    }
</script>
<style lang="scss" scoped>
    .loading-box {
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 999;
        width: 100%;
        /*height: 100%;*/
        .loading-icon {
            position: absolute;
            left: 50%;
            /*top: 30%;*/
            bottom: -50px;
            transform: translate(-50%, -50%);
            margin: 30px auto;
            width: 20px;
            height: 20px;
            z-index: 55;
        }
        .loading-mask {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            /*background-color: rgba(0, 0, 0, .5);*/
        }
    }
</style>
